import React from 'react';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import './Spinner.scss';

const Spinner = () => <Isvg className="spinner" src={ICONS.spinner} />;

export default Spinner;
